import { Button, Modal, ModalBody, ModalHeader, Table } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import marketSignalApi from '@/modules/market-signals/api/market-signal-api';
import { MarketSignalAlarm } from '@/modules/market-signals/model/market-signals/market-signal-alarm';
import { MarketSignal } from '@/modules/market-signals/model/market-signals/market-signal';
import MarketSignalScrollerEntry from '@/modules/market-signals/components/market-signals/scroller/market-signal-scroller-entry';
import { MarketSignalContext } from '@/modules/market-signals/contexts/market-signal-context';

export default function MarketSignalAlarmModal({
  show,
  onClose,
  alarms,
}: {
  show: boolean;
  onClose: () => void;
  alarms: MarketSignalAlarm[];
}) {
  const [signals, setSignals] = useState<MarketSignal[]>([]);
  const { acknowledgeAlarms, streams, setSelectedStream } = useContext(MarketSignalContext);

  useEffect(() => {
    if (show && alarms.length > 0) {
      marketSignalApi
        .getSignalsByIds(alarms.map(value => value.signalId))
        .then(value => setSignals(value.content));
    }
  }, [show, alarms]);

  const close = () => {
    acknowledgeAlarms(alarms.map(value => value._id));
    setSignals([]);
    onClose();
  };

  const selectStreamAndClose = (s: string) => {
    setSelectedStream(s);
    close();
  };

  return (
    <Modal show={show} size={'lg'} onBackdropClick={close} onHide={close}>
      <ModalHeader>
        <div className={'d-flex w-100 justify-content-between align-items-center'}>
          <div className={'h3'}>Alarms</div>
          <Button onClick={close} variant={'warning'}>
            Close
          </Button>
        </div>
      </ModalHeader>

      <ModalBody>
        <Table responsive>
          <thead>
            <tr>
              <th>Alarm</th>
              <th>Streams</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {signals.map(value => (
              <tr key={value._id}>
                <td className={'small'}>
                  <MarketSignalScrollerEntry signal={value} />
                </td>
                <td className={'w-25'}>
                  {value.streams.map(value1 => (
                    <div key={`${value._id}-${value1}`} className={'mb-1'}>
                      <Button
                        variant={'outline-secondary'}
                        size={'sm'}
                        onClick={event => selectStreamAndClose(value1)}
                      >
                        {streams.find(s => s.code === value1)?.name || value1}
                      </Button>
                    </div>
                  ))}
                </td>
                <td className={'w-25'}>
                  {alarms
                    .filter(value1 => value1.signalId === value._id)
                    .map(a => (
                      <p key={a._id}>{a.reason}</p>
                    ))}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  );
}
